const ROUTES = (lang: string = 'en-nz') => {
  const currentLang = lang === 'en-nz' ? '' : `/${lang}`;

  const subscriptionUrl =
    process.env.GATSBY_RT_19_02_2024_ACCOUNT_OVERVIEW === 'true'
      ? '/subscription'
      : '/change-subscription';

  return {
    SUBSCRIPTION: `${currentLang}${subscriptionUrl}`,
    ACCOUNT: `${currentLang}/account`,
    OFFER_REDEMPTION: `${currentLang}/offer-redemption`,
    ACCOUNT_DETAILS: `${currentLang}/account-details`,
    BILLING_HISTORY: `${currentLang}/billing-history`,
    UPDATE_PAYMENT_DETAILS: `${currentLang}/update-payment-details`,
    LOGIN: `${currentLang}/login`,
    LMOD_SURVEY: `${currentLang}/survey/start`,
    RESET_PASSWORD: `${currentLang}/reset-password`,
    RESELLER_REDEEM: `${currentLang}/reseller-redeem`,
    FEDERATED_SIGNUP: `${currentLang}/federated-signup`,
    FORGOT_PASSWORD: `${currentLang}/forgot-password`,
  };
};

export default ROUTES;
